import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function AutumnBlock({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  const [questions, setQuestions] = useState([]);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac

  //questions section
  var questionsYear2AutumnAdditionSubtraction = [];
  questionsYear2AutumnAdditionSubtraction.push({ "question" : "Emile has made a number. What number has Emile made? ", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "Aimee has also made a number. What number has Aimee made? ", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "What is the total of Emile's and Aimee's numbers? ", "answer" : "38", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "What is the difference between Emile's and Aimee's numbers? ", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "Work out 27 - 9 using the number line. ", "answer" : "18", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "Emile has 27 red gems and 8 blue gems. How many red and blue gems does Emile have? ", "answer" : "35", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "What number is missing from the part-whole model? ", "answer" : "13", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "What number is missing from the part-whole model? ", "answer" : "48", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnAdditionSubtraction.push({ "question" : "What number is missing from the part-whole model? ", "answer" : "11", "type": 0, "units" : "", "marks" : 1})



  
  

  var questionsYear2AutumnMoney = [];
  questionsYear2AutumnMoney.push({ "question" : "How much money is shown? ", "answer" : "4", "type": 0, "units" : "p", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "How much money is shown? ", "answer" : "34", "type": 0, "units" : "p", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "How much money is shown? ", "answer" : "15", "type": 0, "units" : "£", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "Who has more money, Emile or Aimee? ", "answer" : "Aimee|Emile", "type": 4, "units" : "", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "How much more money does Emile or Aimee have? ", "answer" : "40", "type": 0, "units" : "p", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "What number is missing from the part-whole model?", "answer" : "10", "type": 0, "units" : "£", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "What number is missing from the part-whole model?", "answer" : "6", "type": 0, "units" : "£", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "Below is a price list of different colours of gems. How much does a red and blue gem cost altogether?", "answer" : "38", "type": 0, "units" : "£", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "Below is a price list of different colours of gems. What is the most expensive gem?", "answer" : "Purple|Green|Red", "type": 1, "units" : "", "marks" : 1})
questionsYear2AutumnMoney.push({ "question" : "Below is a price list of different colours of gems. If Emile buys 2 red gems and pays with a £50 note, how much change will he receive?", "answer" : "18", "type": 0, "units" : "£", "marks" : 1})

  

  

  var questionsYear2AutumnMultiplication = [];
  questionsYear2AutumnMultiplication.push({ "question" : "There are how many groups of gems? ", "answer" : "4", "type": 0, "units" : "groups", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "Which addition sentence works out the total number of gems?", "answer" : "3 + 3 + 3 + 3|3 + 3 + 3|3 + 3", "type": 1, "units" : "", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "Which multiplication sentence works out the total number of gems? ", "answer" : "3 x 4|3 x 3|3 x 2", "type": 1, "units" : "", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "How many gems are there altogether? ", "answer" : "12", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "Using the bar model, what is 4 x 8?", "answer" : "32", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "Each crate of gems has 10 gems. How many gems in total are in 5 crates? ", "answer" : "50", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2AutumnMultiplication.push({ "question" : "Emile has four 2 pence coins. How much money does he have?", "answer" : "8", "type": 0, "units" : "p", "marks" : 1})

  
  
  
  var questionsYear2AutumnPlaceValue = [];
  questionsYear2AutumnPlaceValue.push({ "question" : "How many gems are there? ", "answer" : "16", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "How many gems are there? ", "answer" : "23", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Which is the largest number? ", "answer" : "42|38|29", "type": 1, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Complete the part-whole model.", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Complete the part-whole model.", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Complete the part-whole model.", "answer" : "25", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Emile has made a number. What number has he made? ", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Aimee has made a number. What number has she made? ", "answer" : "23", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "Scrambler has drawn a number line. What number has he labelled A? ", "answer" : "40", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "1 more than 26 is ?", "answer" : "27", "type": 0, "units" : "", "marks" : 1})
questionsYear2AutumnPlaceValue.push({ "question" : "1 less than 37 is? ", "answer" : "36", "type": 0, "units" : "", "marks" : 1})





  var questionsYear3AutumnAdditionSubtraction = [];
  questionsYear3AutumnAdditionSubtraction.push({ "question" : "Emile makes a number with counters. If he subtracts thirty, what is Emile's new number? ", "answer" : "324", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from the part-whole model? ", "answer" : "70", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from the part-whole model? ", "answer" : "970", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "Calculate:", "answer" : "68", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "Calculate:", "answer" : "88", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "Calculate:", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from the bar model? ", "answer" : "321", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from the bar model? ", "answer" : "200", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from this addition calculation?", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnAdditionSubtraction.push({ "question" : "What is the number missing from this subtraction calculation?", "answer" : "7", "type": 0, "units" : "", "marks" : 1})





  var questionsYear3AutumnMultiplicationDivision = [];
  questionsYear3AutumnMultiplicationDivision.push({ "question" : "How many crates of 10 gems are there?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Each crate of gems has 10 gems inside. If Emile has 3 crates. How many gems does he have? ", "answer" : "30", "type": 0, "units" : "gems", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Calculate:", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Calculate:", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Complete the bar model. ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Using the array, 3 x 4 = ?", "answer" : "12", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "Red gems cost £5. Silver gems cost 4 times as much. How much does a silver gem cost? ", "answer" : "20", "type": 0, "units" : "£", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "What is the missing number?", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnMultiplicationDivision.push({ "question" : "What is the missing number?", "answer" : "4", "type": 0, "units" : "", "marks" : 1})


  

  var questionsYear3AutumnPlaceValue = [];
  questionsYear3AutumnPlaceValue.push({ "question" : "Emile has made a number. What number has Emile made? ", "answer" : "642", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "Aimee has made a number. What number has Aimee made? ", "answer" : "321", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "Scrambler has marked a number on the number line. What number has Scrambler marked? ", "answer" : "125", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "Which number is even? ", "answer" : "352|253|325", "type": 1, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "Which number has a digit 6 in the tens column? ", "answer" : "562|652|256", "type": 1, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "Which number is three hundred and fifty-three?", "answer" : "353|333|533", "type": 1, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "What is 10 less than 523?", "answer" : "513", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "What is 100 more than 523?", "answer" : "623", "type": 0, "units" : "", "marks" : 1})
questionsYear3AutumnPlaceValue.push({ "question" : "What is 100 less than 523?", "answer" : "423", "type": 0, "units" : "", "marks" : 1})



  

  var questionsYear4AutumnAdditionSubtraction = [];
  questionsYear4AutumnAdditionSubtraction.push({ "question" : "Aimee is adding 5,632 and 3,345 together using a place value table. What is the answer 5,632 + 3,345 = ?", "answer" : "8977", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "Emile has made a number. Scrambler steals 4 ones, 5 tens and 6 hundreds. What number is left?", "answer" : "322", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "Aimee has made a bar model to represent her gem collection. What is the missing number? ", "answer" : "201", "type": 0, "units" : "green gems", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "Calculate 349 - 173", "answer" : "176", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "What symbol is missing? ", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "654 + 123 = 123 + ?", "answer" : "654", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "654 + 123 = 655 + ?", "answer" : "122", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "654 + 123 = 554 + ?", "answer" : "223", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "1,876 rounded to the nearest thousand is? ", "answer" : "2000", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnAdditionSubtraction.push({ "question" : "7,896 + 1,120 is approximately? ", "answer" : "9000|10000|8000", "type": 1, "units" : "", "marks" : 1})



  

  var questionsYear4AutumnLengthPerimeter = [];
  questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : "=|>|<", "type": 1, "units" : "", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the missing symbol? ", "answer" : "<|=|>", "type": 1, "units" : "", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the number missing from the bar model? ", "answer" : "700", "type": 0, "units" : "metres", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the perimeter of the shape? ", "answer" : "20", "type": 0, "units" : "cm", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the perimeter of the shape? ", "answer" : "22", "type": 0, "units" : "cm", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the perimeter of the shape? ", "answer" : "20", "type": 0, "units" : "cm", "marks" : 1})
questionsYear4AutumnLengthPerimeter.push({ "question" : "What is the perimeter of the shape? ", "answer" : "12", "type": 0, "units" : "cm", "marks" : 1})

  


  var questionsYear4AutumnMultiplicationDivision = [];
  questionsYear4AutumnMultiplicationDivision.push({ "question" : "What number is missing from the bar model? ", "answer" : "20", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "Calculate: ", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "Calculate: ", "answer" : "1000", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "Calculate: ", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "What is the missing number? ", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "Using the array, calculate 8 x 4", "answer" : "32", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "A red gem costs £7. Emile buys six red gems. How much does Emile spend? ", "answer" : "42", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "What is the product of 6 and 5?", "answer" : "30", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "What is the sum of 6 and 5?", "answer" : "11", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnMultiplicationDivision.push({ "question" : "What is the value of a silver gem if: 7 green gems are £28 and 1 silver gem costs the same as 3 greens gems?", "answer" : "12", "type": 0, "units" : "£", "marks" : 1})


  


  var questionsYear4AutumnPlaceValue = [];
  questionsYear4AutumnPlaceValue.push({ "question" : "Emile has made a number on a place value grid. What number has he made? ", "answer" : "2357", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Aimee has made a number. What number has she made? ", "answer" : "468", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Scrambler has marked a number on a number line. What number has he marked? ", "answer" : "800", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Below is a part whole model. What number is missing?", "answer" : "7429", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Below is a part whole model. What number is missing?", "answer" : "800", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Below is a part whole model. What number is missing?", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Calculate: ", "answer" : "4396", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "What is the missing number?", "answer" : "3250", "type": 0, "units" : "", "marks" : 1})
questionsYear4AutumnPlaceValue.push({ "question" : "Which number is even?", "answer" : "3792|2793|3729", "type": 1, "units" : "", "marks" : 1})



  var questionsYear5AutumnAdditionSubtraction = [];
  questionsYear5AutumnAdditionSubtraction.push({ "question" : "Emile has made a number. What number has Emile made? ", "answer" : "3214", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "Aimee has made a number. What number has Aimee made? ", "answer" : "3521", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "Scrambler has made a bar model. What is the missing number? ", "answer" : "4745", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "What is the missing number? ", "answer" : "3100", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "What is the missing number? ", "answer" : "4100", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "Calculate: ", "answer" : "5322", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "Calculate: ", "answer" : "182600", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "What is the missing digit?", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "What is the missing number? ", "answer" : "23269", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnAdditionSubtraction.push({ "question" : "Emile buys a new rocket for £17,500. Scrambler buys a new rocket for £39,750. How much more did Scrambler spend on his rocket? ", "answer" : "22250", "type": 0, "units" : "£", "marks" : 1})




  var questionsYear5AutumnAreaPerimeter = [];
  questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the perimeter of the rectangle?", "answer" : "16", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the area of the rectangle?", "answer" : "12", "type": 0, "units" : "cm²", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the perimeter of the equilateral triangle shown? ", "answer" : "12", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the perimeter of the regular pentagon shown?", "answer" : "10", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the perimeter of the parallelogram shown? ", "answer" : "16", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What symbol is missing? ", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "Emile needs a new carpet for a room in his rocket. The room is 4m by 6m. What area of carpet is needed? ", "answer" : "24", "type": 0, "units" : "m²", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "How big is side A? ", "answer" : "10", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "How big is side B? ", "answer" : "8", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the perimeter of the shape? ", "answer" : "44", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5AutumnAreaPerimeter.push({ "question" : "What is the area of the shape? ", "answer" : "104", "type": 0, "units" : "cm²", "marks" : 1})


  var questionsYear5AutumnMultiplicationDivision = [];
  questionsYear5AutumnMultiplicationDivision.push({ "question" : "Emile buys 1 gem for £2. How much would 10 gems cost? ", "answer" : "20", "type": 0, "units" : "£", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Aimee has made an array of gems. What calculation does the array relate to? ", "answer" : "5 x 3|5 x 4|4 x4", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Which number is a multiple of 4?", "answer" : "24", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Which number is a square number? ", "answer" : "16", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Which number is a factor of 12? ", "answer" : "6|5|8", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Which number is a prime number? ", "answer" : "5|6|9", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Scrambler buys 20 crates, each crate containing 15 gems. How many gems has Scrambler bought? ", "answer" : "300", "type": 0, "units" : "gems", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Complete the statement. ", "answer" : "x 10|x 100|÷ 10", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Complete the statement. ", "answer" : "x 100|x 10|÷ 10", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Complete the statement. ", "answer" : "÷ 10|x 100|x 10", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnMultiplicationDivision.push({ "question" : "Aimee buys gems in crates. Each crate holds the same number of gems. and each crate holds a <b>prime</b> number of gems. Aimee buys 6 crates. How many gems could she have bought?", "answer" : "66|54|72", "type": 1, "units" : "gems", "marks" : 1})

  
  var questionsYear5AutumnPlaceValue = [];
  questionsYear5AutumnPlaceValue.push({ "question" : "Emile has made a number. What number has Emile made? ", "answer" : "46032", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "Which number rounds to 2,500 to the nearest ten?", "answer" : "2496|2510|2555", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What number is missing? ", "answer" : "37280", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What number is missing? ", "answer" : "6000", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What number is missing? ", "answer" : "0", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What number is missing from the bar model? ", "answer" : "4000", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "Scrambler has marked a number on a number line. What number has he marked? ", "answer" : "86000", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "Aimee has marked a number on a number line. What number has she marked? ", "answer" : "870000", "type": 0, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What is 52 - 57?", "answer" : "-5|5|0", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What symbol is missing? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnPlaceValue.push({ "question" : "What symbol is missing? ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})


  var questionsYear5AutumnStatistics = [];
  questionsYear5AutumnStatistics.push({ "question" : "The table below shows how many gems are on each planet. How many red gems are on the planet called \"Tortuga\"? ", "answer" : "606", "type": 0, "units" : "gems", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The table below shows how many gems are on each planet. How many blue  and purple gems in total are on the planet called \"Abydos\"? ", "answer" : "1127", "type": 0, "units" : "gems", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The table below shows how many gems are on each planet. How many more purple gems are on the planet Primus than Caramella?", "answer" : "219", "type": 0, "units" : "gems", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The graph below shows the engine temperature as the rocket takes off and settles into orbit. How long does it take for the rocket to reach 2,700 degrees?", "answer" : "100", "type": 0, "units" : "seconds", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The graph below shows the engine temperature as the rocket takes off and settles into orbit. How long does the rocket stay at 2300 degrees?", "answer" : "20", "type": 0, "units" : "seconds", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The graph below shows the engine temperature as the rocket takes off and settles into orbit. How long does it take to go from 0 degrees to 2,400 degrees? ", "answer" : "80", "type": 0, "units" : "seconds", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The table shows the departure times at each planet for a galactic bus. From which planet does the bus leave first? ", "answer" : "Abydos|Polygonia|Tortuga", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The table shows the departure times at each planet for a galactic bus. From which planet does the bus leave at 3.30pm? ", "answer" : "Tortuga|Abydos|Polygonia", "type": 1, "units" : "", "marks" : 1})
questionsYear5AutumnStatistics.push({ "question" : "The table shows the departure times at each planet for a galactic bus. Emile wants to catch the bus from Mechanus. He arrives at 5pm. How long must he wait?", "answer" : "30", "type": 0, "units" : "minutes", "marks" : 1})


  var questionsYear6AutumnAddingSubtractingFractions = [];
  questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Simplify: ", "answer" : "2/3", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Simplify: ", "answer" : "7&1/3", "type": 3, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Which symbol makes the statement true?", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Which symbol makes the statement true?", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Which symbol makes the statement true?", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Calculate: ", "answer" : "7/8", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Calculate: ", "answer" : "7/10", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Calculate: ", "answer" : "1/12", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Calculate: ", "answer" : "6&5/12", "type": 3, "units" : "", "marks" : 1})
questionsYear6AutumnAddingSubtractingFractions.push({ "question" : "Emile uses 1/3 of his fuel on Monday. He uses 1/5 of his fuel on Tuesday. He uses the remaining fuel on Wednesday. What fraction of his fuel did he use on Wednesday? ", "answer" : "7/15", "type": 2, "units" : "", "marks" : 1})


  var questionsYear6AutumnMultiplyingDividingFractions = [];
  questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "What is 4 x 1/5?", "answer" : "4/5", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "What is 4 x 3/5?", "answer" : "12/5", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "What is the missing number?", "answer" : "2", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "What is 2 x 1&1/3?", "answer" : "2&2/3", "type": 3, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Calculate: ", "answer" : "1/6", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Calculate: ", "answer" : "2/15", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Calculate: ", "answer" : "1/8", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Calculate: ", "answer" : "1/4", "type": 2, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "What is the value of A?", "answer" : "28", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Emile buys 5 tanks of fuel. Each tank has 3/4 litres of fuel. How much fuel has he bought?", "answer" : "3&3/4", "type": 3, "units" : "", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Emile travels 5&1/3km each day for 5 days. He then travels 6&2/5km each day for 2 days. How far does he travel? ", "answer" : "39&7/15", "type": 3, "units" : "km", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "Emile has 200 gems. 1/5 of the gems are red. 1/2 the gems are blue. The rest are green. How many green gems does Emile have?", "answer" : "60", "type": 0, "units" : "green gems", "marks" : 1})
questionsYear6AutumnMultiplyingDividingFractions.push({ "question" : "1/3 of Scrambler's gems are red gems and he has 60 red gems. How many gems does Scrambler have? ", "answer" : "180", "type": 0, "units" : "gems", "marks" : 1})


var questionsYear6AutumnOperations = [];
questionsYear6AutumnOperations.push({ "question" : "What is the missing number? ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "What is the missing number? ", "answer" : "9", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Calculate: ", "answer" : "3918", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Calculate: ", "answer" : "6211", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Calculate: ", "answer" : "14070", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Calculate: ", "answer" : "63", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Below is an addition pyramid. What is A?", "answer" : "1700", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Below is an addition pyramid. What is B?", "answer" : "1590", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Below is an addition pyramid. What is C?", "answer" : "3940", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "The planet \"Tortuga\" has 897,000 gems. The planet \"Primus\" has 268,000 fewer gems than the planet Tortuga. How many gems are on the planet Primus? ", "answer" : "629000", "type": 0, "units" : "gems", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "What is the missing number? ", "answer" : "14", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations.push({ "question" : "Emile buys gems in crates of 25 gems. In a warehouse there are 7,345 gems. How many crates of gems are required to pack all the gems? ", "answer" : "294", "type": 0, "units" : "crates", "marks" : 1})


var questionsYear6AutumnOperations2 = [];
questionsYear6AutumnOperations2.push({ "question" : "Which number is even?", "answer" : "3578|8735|5873", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "what is 10²?", "answer" : "100", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Which number is a square number?", "answer" : "121|10|80", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "What is 2³?", "answer" : "8", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "What are the prime factors of 18?", "answer" : "2,3,3|2,2,3|2,3,5", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Calculate: ", "answer" : "23", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Calculate: ", "answer" : "48", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Calculate: ", "answer" : "23", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Calculate: ", "answer" : "7", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnOperations2.push({ "question" : "Emile has 5 boxes of gems. Each box has 6 gems. Aimee has 4 gems. Which sentence represents the total number of gems? ", "answer" : "(5 x 6) + 4|5 x (6 + 4)|6 x (5 + 4)", "type": 1, "units" : "", "marks" : 1})



var questionsYear6AutumnPlaceValue = [];
questionsYear6AutumnPlaceValue.push({ "question" : "What number is missing? ", "answer" : "5000", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "What number is missing? ", "answer" : "53726", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "Emile has marked a number on a number line. What number has he marked? ", "answer" : "850000", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "What symbol is missing? ", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "What is 3,572 rounded to the nearest 100?", "answer" : "3600", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "What is 3,572 rounded to the nearest 1,000?", "answer" : "4000", "type": 0, "units" : "", "marks" : 1})
questionsYear6AutumnPlaceValue.push({ "question" : "The below squence increases by 25 each time. Which box will have 3,325", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})


var questionsYear6AutumnPositionsDirections = [];
questionsYear6AutumnPositionsDirections.push({ "question" : "What is the coordinate of point A?", "answer" : "(8,5)|(4,2)|(1,9)", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPositionsDirections.push({ "question" : "What is the coordinate of point B?", "answer" : "(4,2)|(8,5)|(1,9)", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPositionsDirections.push({ "question" : "What is the coordinate of point C?", "answer" : "(1,9)|(8,5)|(4,2)", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPositionsDirections.push({ "question" : "A rectangle is drawn on a grid with one corner labelled D. If the rectangle is translated 4 right and 3 up, what are the coordinates of point d after the translation?", "answer" : "(8,5)|(4,2)|(1,9)", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPositionsDirections.push({ "question" : "A rectilinear shape is drawn on a grid with one point labelled E. If the rectilinear shape is reflected in the y axis, what are the new coordinates of E?", "answer" : "(4,5)|(5,4)|(-5,-4)", "type": 1, "units" : "", "marks" : 1})
questionsYear6AutumnPositionsDirections.push({ "question" : "What is the perimeter of the rectilinear shape shown on the centimetre grid below?", "answer" : "12", "type": 0, "units" : "cm", "marks" : 1})




  

  var timer = -1;

//above is questions section
  
  console.log(props);

  if (status == false){
    currQuestion = [];
    console.log("STATUS IS FALSE");
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    var query = props.assessment_type[0] + props.assessment_type[3];
    console.log("QUERY IS: " + query)
    //check what questions it is, checking year first will check terms later like summer etc
    if (query == "2autumnaddition&subtraction"){
      setQuestions(questionsYear2AutumnAdditionSubtraction);
    } else if (query == "2autumnmoney"){
      setQuestions(questionsYear2AutumnMoney);
    }
    else if (query == "2autumnmultiplication"){
      setQuestions(questionsYear2AutumnMultiplication);
    }
    else if (query == "2autumnplacevalue"){
      setQuestions(questionsYear2AutumnPlaceValue);
    }
    else if (query == "3autumnaddition&subtraction"){
      setQuestions(questionsYear3AutumnAdditionSubtraction);
    }
    else if (query == "3autumnmultiplication&division"){
      setQuestions(questionsYear3AutumnMultiplicationDivision);
    }
    else if (query == "3autumnplacevalue"){
      setQuestions(questionsYear3AutumnPlaceValue);
    }
    else if (query == "4autumnaddition&subtraction"){
      setQuestions(questionsYear4AutumnAdditionSubtraction);
    }
    else if (query == "4autumnlength&perimeter"){
      setQuestions(questionsYear4AutumnLengthPerimeter);
    }
    else if (query == "4autumnmultiplication&division"){
      setQuestions(questionsYear4AutumnMultiplicationDivision);
    }
    else if (query == "4autumnplacevalue"){
      setQuestions(questionsYear4AutumnPlaceValue);
    }
    else if (query == "5autumnaddition&subtraction"){
      setQuestions(questionsYear5AutumnAdditionSubtraction);
    }
    else if (query == "5autumnarea&perimeter"){
      setQuestions(questionsYear5AutumnAreaPerimeter);
    }
    else if (query == "5autumnmultiplication&division"){
      setQuestions(questionsYear5AutumnMultiplicationDivision);
    }
    else if (query == "5autumnplacevalue"){
      setQuestions(questionsYear5AutumnPlaceValue);
    }
    else if (query == "5autumnstatistics"){
      setQuestions(questionsYear5AutumnStatistics);
    }
    else if (query == "6autumnadding&subtractingfractions"){
      setQuestions(questionsYear6AutumnAddingSubtractingFractions);
    }
    else if (query == "6autumnmultiplying&dividingfractions"){
      setQuestions(questionsYear6AutumnMultiplyingDividingFractions);
    }
    else if (query == "6autumnoperations"){
      setQuestions(questionsYear6AutumnOperations);
    }
    else if (query == "6autumnoperations2"){
      setQuestions(questionsYear6AutumnOperations2);
    }
    else if (query == "6autumnpositions&directions"){
      setQuestions(questionsYear6AutumnPositionsDirections);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }


  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "BlockAutumn/";
    requireString+= props.assessment_type[0] + props.assessment_type[3] + (questionNum+1) + ".png";
    //requireString += "/question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    //var choices = currQuestion.answer.split("|");
    //choices = shuffleArray(choices);
    let choices = shuffledAnswers[questionNum];

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                }    
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
            </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`